import React from 'react';
import { Typography } from '@material-ui/core';

const LoginText = () => {
  return (
    <Typography className="mt20 textLightGray mb20 floatLeft w100" variant="caption">
      Enter your login credentials below to access your secure portal to view approved agent resources.
      If you are having trouble or questions please email <a href="mailto:niw.selling@simplicitygroup.com">niw.selling@simplicitygroup.com</a>.
    </Typography>
  );
};

export default LoginText;
